'use strict';
module.exports = require('./Chips.vue');